(function ($) {
    function propertiesSlider() {
        $(".product-property-animated-slider").each(function () {
            var $this = $( this );
            var infoSlider = new Swiper($this.find('.swiper-container').get(0), {
                slidesPerView: 'auto',
                spaceBetween: 10,
                centeredSlides: true,
                loop: $this.find('.swiper-slide').length > 1,
                loopAddBlankSlides: true,
                slidesPerGroupAuto: true,
                navigation: {
                    nextEl: '.product-property-animated-slider-next',
                    prevEl: '.product-property-animated-slider-prev',
                },
                pagination: {
                    el: ".swiper-pagination",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 14,
                    }
                }
            });
            window.onresize=function(){
                infoSlider.update();
            }
            if($this.find(".swiper-slide").length === 1){
                infoSlider.destroy();
                $(".product-property-animated-slider__nav").css("display", "none");
            }
        });
    }



    $(document).gp_ready(function (){
        propertiesSlider();
    })

    var w = $(window).width();
    window.addEventListener('resize', () => {
        clearTimeout(window.resizedFinished);
        if ($(window).width() === w) return;
        w = $(window).width();
        window.resizedFinished = setTimeout(function(){
            propertiesSlider();
        }, 250);
    });

})(jQuery);
